module.exports = __webpack_public_path__ + "static/media/despair.f8c26ec0.png";